import _ from 'lodash'

_.mixin({
    mapIds: (obj, arr) => {
        arr.forEach(a => obj[a.id] = a)
        return obj
    },
    unmapIds: (obj, arr) => {
        arr.forEach(a => obj[a.id] = undefined)
        return obj
    }
})

const data = (state = {
    notification: null,
    ETMSUser: null
}, action) => {

    switch (action.type) {

        case 'IS_LOADING':

            const loading = _.clone(state.loading || {})
            if (typeof action.loading === 'object') {
                Object.assign(loading, action.loading)
            }

            return {
                ...state,
                loading: loading
            }

        case 'DATA_ERROR':

            const dataError = _.clone(state.dataError || {})
            if (typeof action.error === 'object') {
                Object.assign(dataError, action.error)
            }

            return {
                ...state,
                dataError: dataError
            }

        case 'NOTIFICATION_RECEIVED':
            return {
                ...state,
                notifications: [...(state.notifications || []), action.notification]
            }
        case 'REMOVE_NOTIFICATION_RECEIVED':
            return {
                ...state,
                notifications: (state.notifications || []).filter(n => n.id !== action.notification.id)
            }

        case 'REMOVE_ALL_NOTIFICATIONS_RECEIVED':
            return {
                ...state,
                notifications: []
            }

        case 'REMOVE_NOTIFICATION_ID_RECEIVED':
            return {
                ...state,
                notifications: (state.notifications || []).filter(n => n.id !== action.notificationId)
            }

        case 'LOG_OUT':

            return {
                ...state,
                ETMSUser: null,
                notification: null
            }

        case 'ETMS_USER_RECEIVED':

            //console.log('got>> ETMS_USER_RECEIVED', action)

            return {
                ...state,
                ETMSUser: action.ETMSUser
            }

        case 'OTHER_ETMS_USER_RECEIVED':

            return {
                ...state,
                selectedGroupUsers: _.mapIds(_.clone(state.selectedGroupUsers || {}), [action.newUser])
            }

        case 'TEST_RECEIVED':
            //console.log('TEST_RECEIVED', action)

            //const x = _.clone(state.tests || {})
            //const y = _.mapIds(_.clone(state.tests || {}), [action.test])
            //console.log('test received', action, x, y, [action.test])

            return {
                ...state,
                test: action.test,
                tests: _.mapIds(_.clone(state.tests || {}), [action.test])
            }

        case 'TESTS_RECEIVED':
            //console.log('TESTS_RECEIVED', action)

            if (action.forAdminReport) {
                return {
                    ...state,
                    reportTests: action.tests || []
                }
            } else {
                return {
                    ...state,
                    tests: _.mapIds(_.clone(state.tests || {}), (action.tests || []))
                }
            }

        case 'DOCUMENT_UPLOADED':
            //console.log('data..', action.uploadUrl)
            return {
                ...state,
                uploadUrl: action.uploadUrl
            }

        case 'GROUP_RECEIVED':
            return {
                ...state,
                group: action.group,
                groups: [...(state.groups || []), action.group]
            }

        case 'USER_GROUP_RECEIVED':
            return {
                ...state,
                ETMSUserGroup: action.group
            }

        case 'GROUPS_RECEIVED':
            return {
                ...state,
                groups: action.groups
            }

        case 'GROUP_USERS_RECEIVED':

            //console.log('GROUP_USERS_RECEIVED', action.groupUsers)

            return {
                ...state,
                selectedGroupUsers: _.mapIds(_.clone(state.selectedGroupUsers || {}), (action.groupUsers || []))
            }

        case 'GROUP_USER_ADDED':

            return {
                ...state,
                selectedGroupUsers: _.mapIds(_.clone(state.selectedGroupUsers || {}), [action.user])
            }

        case 'GROUP_USER_REMOVED':

            //console.log('GROUP_USER_REMOVED', 'user', action.user, 'state.selectedGroupUsers', state.selectedGroupUsers)

            return {
                ...state,
                selectedGroupUsers: _.unmapIds(_.clone(state.selectedGroupUsers || {}), [action.user])
            }

        case 'USER_DELETED':

            return {
                ...state,
                selectedGroupUsers: _.unmapIds(_.clone(state.selectedGroupUsers || {}), [action.user])
            }

        case 'BUDGET_RECEIVED':
            return {
                ...state,
                budget: action.budget
            }

        case 'REPORT_RECEIVED':
            return {
                ...state,
                report: action.report
            }

        case 'MDA_YEARLY_RECEIVED':
            return {
                ...state,
                MDAYearly: action.data
            }

        case 'UNPLANNED_STATUS_RECEIVED':
            //console.log('data UNPLANNED_STATUS_RECEIVED', action.unplannedTestsStatus)
            return {
                ...state,
                unplannedTestsStatus: action.unplannedTestsStatus
            }

        default:
            return state
    }
}

export default data


// WEBPACK FOOTER //
// ./src/reducers/data.js